module.exports = __webpack_public_path__ + "img/exhibition-inactive.4e84aa3b.png";